module.exports = __webpack_public_path__ + "media/site/images/technologies/slack-icon-774b8355cc8173aad4b8d8a7294cbfac.svg";